import { render, staticRenderFns } from "./StandingTimberTotalsCard.vue?vue&type=template&id=dcaa8426&"
import script from "./StandingTimberTotalsCard.vue?vue&type=script&lang=js&"
export * from "./StandingTimberTotalsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports